import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Hero from "./Hero";
import Coalerinfo from "./Coalerinfo";
import BlockchainDiagram from "./Blockchain";
import Faqsec from "./Faqsec";
import Coalerimg from "./Coalerimg";
import FormSec from "./FormSec";
import WhyCoaler from "./WhyCoaler";
import Vendors from "./Vendors";
import FooterCoaler from "./FooterCoaler";
import GetEarlyAccess from "./GetEarlyAccess";
import Footer from "../../Footer";

const CoalerBody = () => {
  useEffect(() => {
    const section = document.querySelector("#coaler");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  return (
    <div className="w-screen overflow-x-hidden">
      <Hero />
      <Coalerinfo />
      <BlockchainDiagram />

      <Coalerimg />

      <WhyCoaler />
      <Vendors />
      <Faqsec />
      <FormSec />
      <Footer />
    </div>
  );
};

export default CoalerBody;
